import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MensagemDialogComponent } from '../mensagem-dialog/mensagem-dialog.component';

@Component({
  selector: 'app-nav-item',
  templateUrl: './nav-item.component.html',
  styleUrls: ['./nav-item.component.css']
})
export class NavItemComponent implements OnInit {

  @Input() item: any;

  constructor(private dialog: MatDialog) { }

  ngOnInit(): void {
  }

  abrirDialog(item: any): void {
    this.dialog.open(MensagemDialogComponent, {
      width: "500px",
      data: {
        titulo: item.nome,
        mensagem: item.mensagem,
      },
    });
  }

}
